import axios from '@/http/axios';

export default {
  fetchList: (config) => {
    return axios.get(`/users/`, config);
  },
  fetch(id, config: any = {}) {
    return axios.get('/users/' + id + '/details', config);
  },
  groups() {
    return axios.get('/users/groups');
  },
  update(id, config) {
    return axios.put('/users/' + id, config);
  },
  changePassword(id, config) {
    return axios.put('/users/' + id + '/change-password', config);
  },
  impersonate(id) {
    return axios.get('/users/' + id + '/impersonate');
  },
  fetchBusinessList(id, config: any = {}) {
    return axios.get('/users/' + id + '/businesses', config);
  },
  activate(id) {
    return axios.put('/users/' + id + '/activate');
  },
  key(id, config: any = {}) {
    return axios.put('/users/' + id + '/key', config);
  },
  deleteBusiness(id, businessOid) {
    return axios.put('/users/' + id + '/businesses/' + businessOid + '/delete');
  },
  updateBusiness(id, businessOid, config: any = {}) {
    return axios.put(
      '/users/' + id + '/businesses/' + businessOid + '/update',
      config
    );
  },
};
